import { useEffect, useRef, useState, useCallback } from "react";

// Runs `fetcher` when `deps` change, ignoring stale responses (only the latest
// request's result is applied). Returns { loading, error, data, reload }.
export function useAsyncData(fetcher, deps) {
  const [state, setState] = useState({ loading: true, error: false, data: null });
  const reqId = useRef(0);

  const reload = useCallback(() => {
    const my = ++reqId.current;
    setState((s) => ({ ...s, loading: true, error: false }));
    Promise.resolve(fetcher())
      .then((data) => {
        if (my === reqId.current) setState({ loading: false, error: false, data });
      })
      .catch(() => {
        if (my === reqId.current) setState({ loading: false, error: true, data: null });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ...state, reload };
}
